'use client';
const SWAN_PUBLIC_ASSET_FOLDER = 'v3-assets';
const SWAN_VERSION = '3.20.0';
const SWAN_HASHED_FOLDER = 'v3';
const SWAN_VERSIONED_FOLDER = 'v3.20.0';

export { SWAN_HASHED_FOLDER, SWAN_PUBLIC_ASSET_FOLDER, SWAN_VERSION, SWAN_VERSIONED_FOLDER };
